import React, { useEffect, useState } from 'react'
import axios from 'axios'
import logo from '../../img/logovhu.png'



export default function MainPage() {
    const [data, setData] = useState([])
    const [mssv, setMssv] = useState('')

    const getData = async () => {
        if (mssv === '') {
            alert('Vui lòng nhập MSSV của bạn.')
        }
        else {
            try {
                const res = await axios.get(`/api/thongtin?mssv=${mssv}`)
                setData(res.data)

            } catch (err) {
                alert(err.response.data.msg)
            }
        }
    }

    const linkify = (text) => {
        if (!text || typeof text !== 'string') return text;
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.split(urlRegex).map((part, i) => {
            if (part.match(urlRegex)) {
                return <a key={i} href={part} target="_blank" rel="noopener noreferrer" className="text-blue-600 font-semibold underline hover:text-blue-800 transition-colors duration-300">{part}</a>;
            }
            return part;
        });
    };

    return (
        <div className='min-h-screen w-full bg-gray-50 flex flex-col'>
            <div className='w-full flex-1 bg-white flex flex-col shadow-sm'>
                {/* Header Section */}
                <div className='bg-gradient-to-r from-blue-900 to-blue-700 p-8 flex flex-col items-center justify-center relative shrink-0'>
                    <div className='bg-white p-3 rounded-full shadow-lg mb-4 z-10'>
                        <img src={logo} alt='Logo' className='w-20 h-auto' />
                    </div>
                    <h1 className='text-3xl md:text-4xl text-white font-extrabold text-center drop-shadow-md z-10 uppercase tracking-wide'>
                        THÔNG TIN LỊCH SINH HOẠT ĐẦU KHÓA
                    </h1>
                </div>

                <div className='p-6 sm:p-10 flex-1 flex flex-col items-center'>
                    {/* Search Section */}
                    <div className='w-full max-w-lg flex flex-col sm:flex-row gap-4 mb-10'>
                        <input
                            type='text'
                            name='mssv'
                            placeholder='Nhập mã số sinh viên...'
                            value={mssv}
                            onChange={(e) => { setMssv(e.target.value) }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    getData();
                                }
                            }}
                            className='flex-1 border-2 border-blue-100 bg-white rounded-full shadow-sm px-6 py-3 text-center sm:text-left text-gray-700 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-300 text-lg'
                        />
                        <button
                            className='bg-orange-500 hover:bg-orange-600 text-white font-bold px-8 py-3 rounded-full shadow-md hover:shadow-lg transition-all duration-300 text-lg flex items-center justify-center'
                            onClick={getData}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                            Tra Cứu
                        </button>
                    </div>

                    {/* Info Card Section */}
                    {data.mssv && (
                        <div className='w-full'>
                            <div className='bg-blue-50 border border-blue-100 rounded-2xl p-6 sm:p-8 mb-8 shadow-inner'>
                                <h2 className='text-xl font-bold text-blue-900 mb-6 flex items-center border-b border-blue-200 pb-3'>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                    </svg>
                                    Thông Tin Sinh Viên
                                </h2>
                                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6'>
                                    <div className='bg-white p-4 rounded-xl shadow-sm border border-gray-100'>
                                        <p className='text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1'>Họ và Tên</p>
                                        <p className='text-lg font-bold text-gray-800'>{data.ten ? data.ten.toUpperCase() : 'N/A'}</p>
                                    </div>
                                    <div className='bg-white p-4 rounded-xl shadow-sm border border-gray-100'>
                                        <p className='text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1'>MSSV</p>
                                        <p className='text-lg font-bold text-blue-700'>{data.mssv}</p>
                                    </div>
                                    {/* <div className='bg-white p-4 rounded-xl shadow-sm border border-gray-100'>
                                        <p className='text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1'>Mã Lớp</p>
                                        <p className='text-lg font-bold text-gray-800'>{data.malopsv}</p>
                                    </div> */}
                                    <div className='bg-white p-4 rounded-xl shadow-sm border border-gray-100 sm:col-span-2 md:col-span-1'>
                                        <p className='text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1'>Khoa</p>
                                        <p className='text-lg font-bold text-gray-800'>{data.khoa}</p>
                                    </div>
                                    <div className='bg-white p-4 rounded-xl shadow-sm border border-gray-100 sm:col-span-2'>
                                        <p className='text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1'>Ngành</p>
                                        <p className='text-lg font-bold text-gray-800'>{data.nganh}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Content Section */}
                            {data.noidung && data.noidung.length > 0 && (
                                <div className='w-full'>
                                    <h2 className='text-xl font-bold text-red-600 mb-6 flex items-center'>
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                        </svg>
                                        Nội Dung Lưu Ý Quan Trọng
                                    </h2>
                                    <div className='space-y-4'>
                                        {data.noidung.map((n, i) => (
                                            <div key={i} className='flex bg-white rounded-xl shadow-sm border border-orange-100 overflow-hidden hover:shadow-md transition-shadow duration-300'>
                                                <div className='bg-orange-500 text-white font-bold flex items-center justify-center w-12 shrink-0 text-xl'>
                                                    {i + 1}
                                                </div>
                                                <div className='p-5 text-gray-700 leading-relaxed whitespace-pre-wrap flex-1 text-[15px]'>
                                                    {linkify(n)}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

